// extracted by mini-css-extract-plugin
export default {"stackContainer":"Stack_stackContainer__6JHZr","frontTitle":"Stack_frontTitle__TBQ3A","frontStack":"Stack_frontStack__uOP5O","name":"Stack_name__r53Gc","tech":"Stack_tech__0tuHg"};